import { AgentInteractionStatus } from "../constants/callSession";

export const callSessionStatesAllowingTransfer: AgentInteractionStatus[] = [
	//#warning-ts [code-logic:potential-bug]: when accepting an outbound call as a target, maybe cold transfer should not be allowed
	AgentInteractionStatus.Active,
	AgentInteractionStatus.WarmTransferInviteRejected,
	AgentInteractionStatus.WarmCanceledBySecondAgent,
	AgentInteractionStatus.WarmCanceled,
	AgentInteractionStatus.CalleeUnavailable,
	AgentInteractionStatus.Resumed,
	AgentInteractionStatus.Paused,
];

export const callSessionStatesDisablingCallButton: AgentInteractionStatus[] = [
	AgentInteractionStatus.Offering,
	AgentInteractionStatus.ReceivingWarmTransferInvitation,
	AgentInteractionStatus.AcceptedWarmTransferInvitation,
	AgentInteractionStatus.WarmTransferInviteSent,
	AgentInteractionStatus.WarmTransferInviteAccepted,
	AgentInteractionStatus.WarmTransferConsultingCaller,
	AgentInteractionStatus.WarmTransferConsultingAgent,
];

export const callSessionStatesAllowingOperatorEmail: AgentInteractionStatus[] = [
	AgentInteractionStatus.Active,
	AgentInteractionStatus.WarmTransferInviteRejected,
	AgentInteractionStatus.WarmCanceledBySecondAgent,
	AgentInteractionStatus.WarmCanceled,
	AgentInteractionStatus.CalleeUnavailable,
	AgentInteractionStatus.Resumed,
	AgentInteractionStatus.WarmTransferInviteSent,
	AgentInteractionStatus.WarmTransferInviteAccepted,
	AgentInteractionStatus.WarmTransferConsultingCaller,
	AgentInteractionStatus.WarmTransferConsultingAgent,
	AgentInteractionStatus.Paused,
]
